/* Product card B1: opens/closes the weight & grind bottom sheet.
   The sheet lives inside the card's <form>, so cs-card-picker.js and <cs-quick-add> keep working unchanged. */
(function () {
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-cs-sheet-open]');
    if (open) {
      var d = open.closest('form') && open.closest('form').querySelector('dialog.cs-sheet');
      if (d && !d.open) { e.preventDefault(); d.showModal(); }
      return;
    }
    var close = e.target.closest && e.target.closest('[data-cs-sheet-close]');
    if (close) { var c = close.closest('dialog'); if (c) c.close(); return; }
    // Tap on the dimmed backdrop closes the sheet
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('cs-sheet')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) e.target.close();
    }
  });
  // After "Add" the cart drawer opens; close the sheet so it doesn't sit on top
  document.addEventListener('submit', function (e) {
    var d = e.target.querySelector && e.target.querySelector('dialog.cs-sheet[open]');
    if (d) setTimeout(function () { d.close(); }, 150);
  });
})();